import styled from '@emotion/styled';
import { IEnrichedFlight } from '../../../shared/flight/domain/models/IEnrichedFlight';
import * as Airline from './columns/Airline';
import * as Airport from './columns/Airport';
import * as DetailsLink from './columns/DetailsLink';
import * as Time from './columns/Time';
import * as FlightNumber from './columns/FlightNumber';
import * as Gate from './columns/Gate';
import * as Status from './columns/Status';
import * as BaggageBelt from './columns/BaggageBelt';
import { Responsive } from '../../../../../ui';
import { FlightListScope } from '../../domain/constants/FlightListScope';
import { StyledRow } from './FlightList';

interface IItemProps {
	flight: IEnrichedFlight;
	scope: FlightListScope;
}

export const CellGroup = styled.div`
	display: flex;
	align-items: flex-start;
	flex: 1;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		flex-direction: column;
		justify-content: space-between;

		&:last-of-type {
			align-items: flex-end;
		}
	}
`;

export function FlightListRow({ flight, scope }: IItemProps) {
	return (
		<StyledRow>
			<Time.Cell
				scheduledTimeStamp={flight.scheduledTimestamp}
				actualTimestamp={flight.actualTimestamp}
			/>
			<CellGroup>
				<Airport.Cell
					airportDetails={
						flight.arrival
							? flight.departureAirportDetails
							: flight.viaAirportDetails
					}
					airport={flight.arrival ? flight.departureAirport : flight.viaAirport}
				/>
				<FlightNumber.Cell
					codeShareFlightNumber={flight.codeShareFlightNumber}
				/>
			</CellGroup>
			<Gate.Cell gate={flight.gate} />
			{scope === FlightListScope.Arrivals && (
				<BaggageBelt.Cell baggageBelt={flight.baggageBelt} />
			)}
			<Airline.Cell
				airlineDetails={flight.airlineDetails}
				icaoOperatingAirline={flight.icaoOperatingAirline}
			/>
			<CellGroup>
				<Status.Cell status={flight.status} />
				<DetailsLink.Cell flight={flight} scope={scope} />
			</CellGroup>
		</StyledRow>
	);
}
